
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { loginAPI, logoutAPI } from '../services/apiLogin';
import { getEnv } from '../config';

export const handleExternalAuth = createAsyncThunk(
  'auth/handleExternalAuth',
  async (code, { rejectWithValue }) => {
    try {
      const redirect_ur= (getEnv("REACT_APP_API_URL_REDIRECT") ? getEnv("REACT_APP_API_URL_REDIRECT") : 'https://portal-web-idecaba-dev.gcba.gob.ar/') +'auth/callback'
      const response = await loginAPI(code, redirect_ur);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);


export const logoutUser = createAsyncThunk(
  'auth/logout',
  async (_, { rejectWithValue }) => {
    try {
      const response = await logoutAPI();
      
      if (response.active === false) {
        return null
      }else if (response.active === true && response.id_token) {
      // Redirect to Keycloak logout URL to invalidate the session
      const keycloakLogoutUrl = `${getEnv("REACT_APP_EXTERNAL_LOGOUT_URL") ? getEnv("REACT_APP_EXTERNAL_LOGOUT_URL") : 'https://identidad-gcaba-hml.apps.buenosaires.gob.ar/realms/open-id/protocol/openid-connect/logout'}?id_token_hint=${response.id_token}&post_logout_redirect_uri=${encodeURIComponent(getEnv("REACT_APP_API_URL_REDIRECT") ? getEnv("REACT_APP_API_URL_REDIRECT") : 'https://portal-web-idecaba-dev.gcba.gob.ar/')}`;
       window.location.href = keycloakLogoutUrl ; 
      return null;
      }else if (response.active === true && !response.id_token){
        return null;
      }
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const initialState = {
  user: null,
  token: null,
  isAuthenticated: false,
  isLoading: false,
  error: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
      localStorage.removeItem('auth');
    },
    restoreSession: (state) => {
      const storedAuth = localStorage.getItem('auth');
      if (storedAuth) {
        const parsedAuth = JSON.parse(storedAuth);
        state.user = parsedAuth.usuario;
        state.token = parsedAuth.token;
        state.isAuthenticated = true;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(handleExternalAuth.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(handleExternalAuth.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isAuthenticated = true;
        state.user = action.payload.usuario;
        state.token = action.payload.token;
        localStorage.setItem('auth', JSON.stringify({
          usuario: action.payload.usuario,
          token: action.payload.token
        }));
      })
      .addCase(handleExternalAuth.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(logoutUser.fulfilled, (state) => {
        state.user = null;
        state.token = null;
        state.isAuthenticated = false;
        localStorage.removeItem('auth');
      });
  },
});

export const { logout, restoreSession } = authSlice.actions;
export default authSlice.reducer;
